<template>
  <div class="home-balance-summary-loader">
    <BaseText size="sm">Patrimônio total</BaseText>
    <SkeletonLoader>
      <div class="home-balance-summary-loader__total" />
      <div class="home-balance-summary-loader__total-subtitle" />
    </SkeletonLoader>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { SkeletonLoader, BaseText } from '@warrenbrasil/nebraska-web';

@Component({
  components: { SkeletonLoader, BaseText }
})
export default class HomeBalanceSummaryLoader extends Vue {}
</script>

<style lang="less" scoped>
.home-balance-summary-loader {
  width: 100%;
  color: @text-over-image;

  &__total,
  &__earnings {
    border-radius: @size-radius-x200;
    opacity: 0.9;
  }

  &__total {
    height: 56px;
    max-width: 350px;
    margin-bottom: @size-spacing-x150;

    .to-sm({height: 40px;});

    &-subtitle {
      border-radius: @size-radius-x200;
      opacity: 0.9;
      height: 22px;
      max-width: 170px;
    }
  }
}
</style>
